<template>
  <SfDropdown
    align-option="l"
    drawer-direction="left"
    :dropdown-id="dropdownId"
    :is-open="isOpen"
    variant="seamless"
    class="period-selection-lock-type-dropdown"
    @dropdown-trigger-clicked="handleToggleDropdown"
  >
    <template #trigger>
      <PeriodSelectionTrigger
        :period-selection-option="periodSelectionOption"
        :is-parent-selected="isParentSelected"
        :value="selectedLockTypeLabel"
      >
        <SfButtonDs variant="secondary" size="sm" type="button">
          {{ selectedLockTypeLabel }}
          <span class="fa fa-caret-down tw-ml-1.5 tw-shrink-0" />
        </SfButtonDs>
      </PeriodSelectionTrigger>
    </template>

    <template #menu>
      <SfDropdownItem
        v-for="lockTypeOption in lockTypeOptions"
        :key="lockTypeOption.key"
        :has-checkmark="selectedLockType === lockTypeOption.key"
        @click="handleLockTypeSelected(lockTypeOption.key)"
      >
        {{ lockTypeOption.title }}
      </SfDropdownItem>
    </template>
  </SfDropdown>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import PeriodSelectionTrigger from './period-selection-trigger.vue'
import type { LockType, PeriodSelectionOption } from '../types'
import { lockTypes } from '../types'
import { lockTypeLabel, lockTypeTitle } from '../utils/lock-type-label'

interface Props {
  dropdownId: string
  isOpen: boolean
  isParentSelected: boolean
  periodSelectionOption: PeriodSelectionOption
  selectedLockType?: LockType
}
const props = defineProps<Props>()

const lockTypeOptions = computed(() =>
  Object.values(lockTypes).map((lockType) => ({
    key: lockType,
    title: lockTypeTitle(props.periodSelectionOption.key, lockType),
  }))
)

const selectedLockTypeLabel = computed(() =>
  props.selectedLockType
    ? lockTypeLabel(props.periodSelectionOption.key, props.selectedLockType)
    : ''
)

const emit =
  defineEmits<{
    'lock-type-selected': [lockType: LockType]
    'toggle-dropdown': []
  }>()

const handleLockTypeSelected = (lockType: LockType) => {
  emit('lock-type-selected', lockType)
}

const handleToggleDropdown = () => {
  emit('toggle-dropdown')
}
</script>
<style>
.period-selection-lock-type-dropdown .sf-dropdown2-menu {
  min-width: initial;
  width: auto;
}
</style>
